import React from 'react';
import { Helmet } from 'react-helmet';

import { css } from '@emotion/react';

import { Footer } from '../components/Footer';
import SiteNav from '../components/header/SiteNav';
import { PostFullContent } from '../components/PostContent';
import { Wrapper } from '../components/Wrapper';
import IndexLayout from '../layouts';
import {
  inner,
  outer,
  SiteArchiveHeader,
  SiteHeader,
  SiteMain,
  SiteNavMain,
  NumColumn,
} from '../styles/shared';
import { NoImage, PostFull, PostFullHeader, PostFullTitle } from '../templates/post';
import { colors } from '../styles/colors';

const PageTemplate = css`
  .site-main {
    margin-top: 64px;
    padding-bottom: 4vw;
    background: #fff;
  }

  @media (prefers-color-scheme: dark) {
    .site-main {
      /* background: var(--darkmode); */
      background: ${colors.darkmode};
    }
  }
`;

const About: React.FC = () => (
  <IndexLayout>
    <Helmet>
      <title>About</title>
    </Helmet>
    <Wrapper css={PageTemplate}>
      <header className="site-archive-header no-image" css={[SiteHeader, SiteArchiveHeader]}>
        <div css={[outer, SiteNavMain]}>
          <div css={inner}>
            <SiteNav isHome={false} />
          </div>
        </div>
      </header>
      <main id="site-main" className="site-main" css={[SiteMain, outer]}>
        <div css={inner}>
          <article className="post page" css={[PostFull, NoImage]}>
            <PostFullHeader className="post-full-header">
              <PostFullTitle className="post-full-title">About</PostFullTitle>
            </PostFullHeader>

            <PostFullContent className="post-full-content">
              <div className="post-content">
                <h2>会社概要</h2>
                <p>当社の諸元は以下のようになっています。</p>
                <table>
                  <tr>
                    <td>
                      社名
                    </td>
                    <td>
                      有限会社エイビープラス<span className="english-name">：ABplus Inc.</span>
                    </td>
                  </tr>
                  <tr>
                    <td>代表者</td>
                    <td>取締役 樋田 一幸</td>
                  </tr>
                  <tr>
                    <td>社員数</td>
                    <td>1名</td>
                  </tr>
                  <tr>
                    <td>設立</td>
                    <td>1996年8月</td>
                  </tr>
                  <tr>
                    <td>資本金</td>
                    <td>300万円</td>
                  </tr>
                  <tr>
                    <td>本社所在地</td>
                    <td>〒240-0006<br/>神奈川県横浜市保土ヶ谷区星川 1-24-23-201</td>
                  </tr>
                  <tr>
                    <td>事業内容</td>
                    <td>ソフトウェア開発・販売<br/>コンサルティング</td>
                  </tr>
                  <tr>
                    <td>取引金融機関</td>
                    <td>横浜銀行 保土ヶ谷支店<br/>ゆうちょ銀行</td>
                  </tr>
                </table>

                <h2>事業紹介</h2>
                <p>当社のおかれている状況と主な事業を紹介します。</p>
                <h3>中の人経歴</h3>
                <p>
                  当社は法人にはなっていますが、会社概要からもわかるように、社員は自分一人で、実際にはフリーランスのプログラマです。<br/>それでも設立以来かれこれ二十数年、続けてきました。単なるコーダではなく、顧客の要求を的確に把握し、それを実現することができるアーキテクトでもあったからだと自負しています。
                </p>
                <p>
                  しかし、時代は流れ、ITを業務に組み込むことが当たり前になって、ありとあらゆる分野で優れたパッケージ製品が登場するとともに、顧客のシステム設計技術も向上してきた現在、必要とされるのは、パッケージを前提にした業務システムを製造するための安価な労働力であって、高度なスキルが求められる場は、ごく少なくなってしまいました。
                </p>
                <p>
                  それでも当社は、プログラマという仕事にこだわりたいと思います。
                </p>
                <h3>モバイル・アプリケーション + ウェブ・アプリケーション</h3>
                <p>
                  IT分野では、その黎明期から現在に至るまで、常にダウンサイジングし続けてきました。メインフレームからワークステーションやパーソナルコンピュータへ。
                </p>
                <p>
                  そして、もう既にポストPC時代。当社としても、これまでのしがらみを捨て、ウェブとモバイルに特化して、あるいはその連携によるシステムの開発に取り組んでいます。
                </p>
                <p>
                  当社とモバイルの関係は、PalmをはじめとするPDAの時代にまでさかのぼります。その視点から見ると、インターネットにつながったスマートフォンというのは、モバイルの完成形のように感じられます。以前はオタクの趣味であったモバイル・コンピューティングが、いま人々の生活のなかで、主要な位置を占める。いいかげん薹の立ったロートルにも燃える時代が再びやってきた。そう感じられます。
                </p>

                <h3>デバッグ</h3>
                <p>
                  デバッグとは、本来、プログラムの不具合を解消するまでのことを意味します。不具合を発見することは、テスト＆デバッグ工程では大切なことですが、発見することと、その問題を解消することは、また別の話です。
                </p>
                <p>
                  何が問題なのかを把握し、またそれを再現し、その原因を追及し、プログラムを修正して、正しく動作することを確認する。言葉で言えばこれだけのことですが、バグの存在自体がイレギュラーなわけですから、こうすればOKというような手順の決まった作業ではなく、勘と経験がものをいう類の話です。 もちろん、それなりの方法論はあるわけですが、万能なものではなく、 置かれた状況から適切な方法を選ぶことが必要です。
                </p>
                <p>
                  三日で作ったモジュールのデバッグで、同じく三日費やすこともありますし、一つのバグで一週間悩み続けることもあります。もし、自分の思いつく原因(と思われるもの)がなくなってしまったとしたら、別の意味でデバッグは終了です。引き出しの数が十分でなければ、デバッグを行うことはできません。
                </p>
                <p>
                  当社では、二十年以上のキャリアを活かして、お客様とともに、原因究明、改善提案、またデバッグそのものを行います。
                </p>

                <h3>リストラクチャリング</h3>
                <p>
                  リストラというと人員削減というような意味で使われる昨今ですが、本来の意味は「再構築」です。
                </p>
                <p>
                  おおよそのシステムは、本来、有るべき姿を模索しながら構築されていきます。「顧客が本当に必要だったもの」は実際にシステムを開発し運用してから、はじめて見えてくるものです。
                </p>
                  しかし、多くのシステムでは、既に稼働しているシステムのコードを改変ことを恐れ、過去の経緯を引きずったまま、不自然な形で機能追加・改修が行われています。不自然は不自然を呼び、経緯を踏まえないと分からない、場合によっては、その経緯を知るものにしか分からないという属人化に繋がっていきます。技術的負債をせっせと蓄えてしまうわけです。
                <p>
                  当社では、システムには「式年遷宮」が必要だと考えています。
                </p>
                <p>
                  不自然な形は有るべき形に、不問律になっている仕様は明文化し、できるだけ最新の技術を用いてシステムを再構築することで、技術的な負債をリセットし、誰でも理解できる状態にしておくことが重要です。そうしておけば、人手が足りないときに急遽増員しても、レクチャーを最低限に抑えることができます。
                </p>

                <h2>経営理念</h2>
                <p>当社が何故設立されたのかを通して、当社の経営理念を紹介します。</p>
                <h3>存在理由</h3>
                <p>
                  当社は、なんのために存在しているか。
                </p>
                <p>
                  実質的には、ただの個人事業主であるのに、なぜ法人になっているかという問いに対しては、単に、その方が便利だったということになってしまうのですが、なぜ、会社員をやめて独立したか、という点について話せば当社のレーゾン・デートルにつながると思います。
                </p>
                <h3>些細なことが我慢できない</h3>
                <p>
                  僕は、些細なことを我慢することが嫌いです。例えば、キーボードが劣化して特定のキーが引っかかるような感じがする。そういうときには、新しいキーボードに買い換えます。プログラマのような頭脳労働では、ちょっとしたことを我慢するだけで、生産性が落ちます。1万円もしないようなものを買い換えるだけで、それを防げるのならば、安いものだと考えます。
                </p>
                <p>
                  しかし、多くの企業では、物品の購入は一社員の判断だけで簡単に行える物ではありません。同様に、安価なツールを購入して使えば、無駄な手間を削減できるような場合でも、それが使えずに手作業で時間をかけて行わなければならないようなこともしばしばあります。
                </p>
                <p>
                  大きなことは我慢せざるを得ないこともあります（もっと広い仕事場が欲しいとか）が、ちょっとしたことで解決する些細なことは、我慢したくありません。これが、当社を設立した動機です。
                </p>
                <h3>IT技術はなんのため</h3>
                <p>
                  当社が扱っているソフトウェアというものは、なんのためにあるのか。端的に言ってしまえば、面倒なことを簡単にすませることができるようにするため、あるいは、手間がかかりすぎて実現不可能なことを可能にするため。そう言い切ってしまってかまわないと思います。
                </p>
                <p>
                  我慢なんかしなくていいんです。そのために、コンピュータとソフトウェア、そしてインターネットがあるのです。人間と野生動物の違いは、道具を作り、使うことで生産性をたかめ、よりよい暮らしを追求することにあります。
                </p>
                <h3>閑話休題</h3>
                <p>
                  あらためて、当社は、なんのために存在しているのか。
                </p>
                <p>
                  ソフトウェアという道具を通じて、自分自身を含めた人々が、我慢することを減らして、より豊かな生活をおくれるようにするために、当社はあります。
                </p>
                <p>
                  「ソフトウェアを通じたQoL(Quality of Life)の追求」こそが、当社の理念です。
                </p>

                <h2>単価表</h2>
                <p>
                  当社では、たんなる労働力の提供を行っているわけではなく、作り上げるソフトウェアの価値を重視しますが、目安は必要と思いますので、以下におもな単価を示します。
                </p>
                <table>
                  <tr>
                    <td>時間単位契約</td>
                    <td css={[NumColumn]}>15,000</td>
                    <td>円/時間</td>
                  </tr>
                  <tr>
                    <td>日単位契約</td>
                    <td css={[NumColumn]}>100,000</td>
                    <td>円/日</td>
                  </tr>
                  <tr>
                    <td>月単位契約</td>
                    <td css={[NumColumn]}>1,500,000</td>
                    <td>円/月</td>
                  </tr>
                  <tr>
                    <td>年間契約</td>
                    <td css={[NumColumn]}>15,000,000</td>
                    <td>円/年</td>
                  </tr>
                  <tr>
                    <td>(宿泊を伴う場合)</td>
                    <td css={[NumColumn]}>+20,000</td>
                    <td>円/泊</td>
                  </tr>
                  <tr>
                    <td>(交通費)</td>
                    <td css={[NumColumn]}>実費</td>
                    <td>(遠距離の場合のみ)</td>
                  </tr>
                </table>
                <p>
                  上記はあくまでも参考であり、作業場所や作業内容等と含めて、お打ち合わせした上で契約条件を決定します。
                </p>
                <p>
                  月単位契約および年間契約の場合、業務に差し支えない範囲で(了解を得た上で)、一月あたり2〜5日程度のお休みをいただくことがあります。
                </p>

              </div>
            </PostFullContent>
          </article>
        </div>
      </main>
      <Footer />
    </Wrapper>
  </IndexLayout>
);

export default About;
